<template>
  <div>
    <v-card>
      <v-card-title>
        <div>
          <div class="headline">Kampagne rapport</div>
          <span class="subtitle-1 light-grey"
            >Filtrér rapporten efter behov. Som standard vises nuværende
            måned.</span
          >
        </div>
        <v-spacer></v-spacer>

        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              icon
              outlined
              color="primary"
              @click="
                filtersTmp = JSON.parse(JSON.stringify(filters));
                filterDialog = true;
              "
            >
              <v-icon small>fas fa-filter</v-icon>
            </v-btn>
          </template>
          <span>Filtrér</span>
        </v-tooltip>
      </v-card-title>
      <v-card-text>
        <campaign-stats-data-table
          :items="stats"
          :loading="loading"
        ></campaign-stats-data-table>
      </v-card-text>
    </v-card>

    <v-dialog v-model="filterDialog" max-width="550px">
      <v-card>
        <v-card-title class="headline" primary-title>
          Filtrér rapport
        </v-card-title>
        <v-card-text>
          <date-picker
            v-model="filtersTmp.start_date"
            label="Periode start"
            cancel-button
            reset-button
          ></date-picker>
          <date-picker
            v-model="filtersTmp.end_date"
            label="Periode slut"
            cancel-button
            reset-button
          ></date-picker>
          <v-flex class="mt-2">
            <business-autocomplete
              v-model="filtersTmp.business_uuid"
              :return-object="false"
            ></business-autocomplete>
          </v-flex>
          <v-flex class="mt-2">
            <influencer-autocomplete
              v-model="filtersTmp.influencer_uuid"
              :return-object="false"
            ></influencer-autocomplete>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            @click="
              filters = cloneDeep(filtersTmp);
              filterDialog = false;
            "
          >
            Filtrér
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import local_numbers from "@/helpers/filters/local_numbers.js";
import search_filters_url from "@/helpers/mixins/search_filters_url";
import DatePicker from "@/components/common/filters/DatePicker";
import CampaignStatsDataTable from "../../data-tables/CampaignStatsDataTable";
import InfluencerAutocomplete from "../../autocompletes/InfluencerAutocomplete";
import BusinessAutocomplete from "../../autocompletes/BusinessAutocomplete";
import { mapActions } from "vuex";

export default {
  components: {
    CampaignStatsDataTable,
    DatePicker,
    InfluencerAutocomplete,
    BusinessAutocomplete
  },
  mixins: [search_filters_url],
  filters: { local_numbers },
  data: () => ({
    stats: [],
    filterDialog: false,
    filtersTmp: {},
    filters: {},
    loading: false
  }),
  watch: {
    filters: {
      handler: function() {
        this.setUrlSearchFilters(this.filters);
        this.getStats();
      },
      deep: true
    }
  },
  methods: {
    ...mapActions("core", { loadStats: "getStats" }),
    getStats() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      const params = {
        ...this.filters,
        group: ["campaign"]
      };
      this.loadStats(params).then(stats => {
        this.stats = stats;
        this.loading = false;
      });
    }
  },
  created() {
    this.filters = this.getUrlSearchFilters();
    if (Object.keys(this.filters).length === 0) {
      this.filters.start_date = this.$moment()
        .startOf("month")
        .format("YYYY-MM-DD");
      this.filters.end_date = this.$moment()
        .endOf("month")
        .format("YYYY-MM-DD");
    } else {
      this.getStats();
    }
  }
};
</script>
